import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import { statesName } from "../../../../TCPForms/data";

const SubStep3 = ({ formData, handleSubTabChange, isEmployee, isReapply }) => {
  const { t } = useTranslation();

  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));

  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, watch, control } = useForm({ defaultValues });

  const watchState = watch("tradeLicenseDetail.owners.[0].permanentAddress.state");

  const onSubmit = (data) => {
    (data.tradeLicenseDetail.owners[0].permanentAddress = { ...data?.tradeLicenseDetail?.owners?.[0]?.permanentAddress, type: "PERMANENT" }),
      (data.tradeLicenseDetail.owners[0].correspondenceAddress = {
        ...data?.tradeLicenseDetail?.owners?.[0]?.permanentAddress,
        type: "CORRESPONDENCE",
      });
    data.tradeLicenseDetail.owners[0].dob =
      parseInt(data?.tradeLicenseDetail?.owners?.[0]?.dateOfBirth?.replace(/-/g, "")) ||
      parseInt(formData?.tradeLicenseDetail?.owners?.[0]?.dateOfBirth?.replace(/-/g, ""));
    handleSubTabChange(3, data);
  };

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("LABEL_CONTACT_INFORMATION")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  label={t("Mobile No")}
                  control={control}
                  placeholder={t("Mobile No")}
                  mobileNumber
                  mandatory
                  type="textInput"
                  name="tradeLicenseDetail.owners.[0].mobileNumber"
                  defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.mobileNumber}
                  disabled={Boolean(formData?.tradeLicenseDetail.owners?.[0]?.mobileNumber) || isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.mobileNumber)}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  maxLength={10}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_STATE")}
                  placeholder={t("Select State")}
                  name="tradeLicenseDetail.owners.[0].permanentAddress.state"
                  defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.state}
                  disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.state)}
                  type="searchSelect"
                  data={statesName}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={updistricts}
                  label={t("LABEL_DISTRICT")}
                  placeholder={watchState === "Uttar Pradesh" ? "Select District" : t("LABEL_ENTER_DISTRICT")}
                  name="tradeLicenseDetail.owners.[0].permanentAddress.district"
                  defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.district}
                  disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.district)}
                  type={watchState === "Uttar Pradesh" ? "selectInput" : "textInput"}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_PINCODE")}
                  placeholder={t("LABEL_ENTER_PINCODE")}
                  name="tradeLicenseDetail.owners.[0].permanentAddress.pinNo"
                  defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.pinNo}
                  disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.pinNo)}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Pincode"),
                      message: "Please enter valid Pincode",
                    },
                  }}
                  maxLength={6}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("LABEL_ADDRESS")}
                  placeholder={t("LABEL_ENTER_ADDRESS")}
                  name="tradeLicenseDetail.owners.[0].permanentAddress.address"
                  defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.address}
                  disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.address)}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Address"),
                      message: "Please enter valid Address",
                    },
                  }}
                  maxLength={2000}
                />
              </Col>
              <Col>
                <InputWrapper
                  label="Email ID"
                  control={control}
                  placeholder={t("LABEL_ENTER_APPLICANT_EMAIL_ID")}
                  name="tradeLicenseDetail.owners.[0].emailId"
                  defaultValue={formData?.tradeLicenseDetail?.owners?.[0]?.emailId}
                  disabled={isEmployee || (isReapply && formData?.tradeLicenseDetail?.owners?.[0]?.emailId)}
                  type="textInput"
                  mandatory
                  maxLength={64}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Email"),
                      message: "Please enter valid email id",
                    },
                  }}
                />
              </Col>
            </Row>
          </Container>
        </div>
        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleSubTabChange(1)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default SubStep3;
